import React from 'react';
import styles from './InsuranceDevice.module.css';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import * as routes from 'app/routes';

import DeviceSelector from 'devices/DeviceSelector';
import Back from 'common/Back';

const SprintInsuranceDevice = ({ subId }) => (
  <div className={styles.InsuranceDevice}>
    <SubscriptionSwitcher
      sprintSubId={subId}
      quickRoute={routes.quickSubscription}
      bypassedRoute={routes.bypassedSubscription}
      sprintRoute={routes.sprintSubscription} 
    />
    <div className={styles.Back}>
      <Back to={routes.sprintSubscription(subId)} />
    </div>
    <h1>
      Device Protection
    </h1>
    <DeviceSelector subId={subId} next={routes.sprintInsurancePlan} />
  </div>
)

export default SprintInsuranceDevice;
